"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannel = exports.EXTChannel = exports.SEEChannel = exports.PAUChannel = exports.IBEChannel = void 0;
exports.IBEChannel = 'IBE'; // Internet default
exports.PAUChannel = 'PAU'; // Pauschal
exports.SEEChannel = 'SEE'; // Seetours
exports.EXTChannel = 'EXT'; // EXPInet (formerly known as Extranet)
function getChannel(priceModel, channel) {
    // every request that comes from EXPInet needs this channel
    if (channel === 'EXT') {
        return channel;
    }
    switch (priceModel) {
        case 'PAUSCHAL':
            return 'PAU';
        case 'SEETOURS':
            return 'SEE';
        default:
            return 'IBE';
    }
}
exports.getChannel = getChannel;
//# sourceMappingURL=channel.js.map